// extracted by mini-css-extract-plugin
export default {"base":"Title_base__Lpst6"};